import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { Observable } from 'rxjs'

import { RestClientService } from './rest.service'

@Injectable()
export class BookService extends RestClientService {
    httproot = 'online/'

    constructor(protected override http: HttpClient) {
        super(http)
    }

    beginClientOnlinePayment(data: any): Observable<any> {
        return this.post<any>(
            this.httproot + 'beginClientOnlinePayment/',
            data,
            { withoutTenant: true }
        )
    }

    getTenantOnlinePaymentMethods(tenantUUID: any): Observable<any> {
        return this.get<any>(
            this.httproot + 'getTenantOnlinePaymentMethods/' + tenantUUID,
            { withoutTenant: true }
        )
    }

    confirmDonation(data: any): Observable<any> {
        return this.post<any>(this.httproot + 'confirmDonation/', data, {
            withoutTenant: true
        })
    }

    getClientPaymentInformation(clientHash: any, key?: any): Observable<any> {
        return this.get<any>(
            this.httproot +
                'getClientPaymentInformation/' +
                clientHash +
                (key ? '/' + key : ''),
            { withoutTenant: true }
        )
    }

    getClientPaymentInformationSecure(clientHash: any): Observable<any> {
        return this.get<any>(
            this.httproot + 'getClientPaymentInformationSecure/' + clientHash,
            { withoutTenant: true }
        )
    }

    verifyClientEmail(data: any): Observable<any> {
        return this.post<any>(this.httproot + 'verifyClientEmail', data, {
            withoutTenant: true
        })
    }

    hideOnlineCancelledClasses(): Observable<any> {
        return this.get<any>(this.httproot + 'hideOnlineCancelledClasses')
    }
}
